// v5.6.5 · Filtros en cascada Franquicia → Institución → Colegio → Salón (admin y franquiciado).
// Uso: <HierarchyFilters value={{franchise_id,institution_id,school_id,classroom_id}} onChange={setValue} />
// Para el franquiciado se omite el selector de franquicia (ya está limitado a la suya en el servidor).
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export const EMPTY_HIER = { franchise_id: "", institution_id: "", school_id: "", classroom_id: "" };
export const hierParams = (v) => Object.fromEntries(Object.entries(v || {}).filter(([, x]) => x));
export const hierActive = (v) => Object.values(v || {}).some(Boolean);

const sel = "jasq-input !py-1.5 !text-xs min-w-[150px]";

export default function HierarchyFilters({ value, onChange, className = "" }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const canUse = isAdmin || user?.role === "franquiciado";
  const [franchises, setFranchises] = useState([]);
  const [insts, setInsts] = useState([]);
  const [schools, setSchools] = useState([]);
  const [rooms, setRooms] = useState([]);
  const v = value || EMPTY_HIER;
  const fr = isAdmin ? v.franchise_id : user?.franchise_id;

  useEffect(() => {
    if (isAdmin) api.get("/franchises").then((r) => setFranchises(r.data || [])).catch(() => {});
  }, [isAdmin]);
  useEffect(() => {
    if (!canUse) return;
    const p = fr ? { franchise_id: fr } : {};
    api.get("/institutions", { params: p }).then((r) => setInsts(r.data || [])).catch(() => setInsts([]));
    api.get("/schools", { params: p }).then((r) => setSchools(r.data || [])).catch(() => setSchools([]));
    api.get("/classrooms", { params: p }).then((r) => setRooms(r.data || [])).catch(() => setRooms([]));
  }, [canUse, fr]);

  if (!canUse) return null;
  const set = (patch) => onChange({ ...v, ...patch });
  const schoolsF = v.institution_id ? schools.filter((s) => s.institution_id === v.institution_id) : schools;
  const roomsF = v.school_id ? rooms.filter((c) => c.school_id === v.school_id) : (v.institution_id ? rooms.filter((c) => c.institution_id === v.institution_id || schoolsF.some((s) => s.id === c.school_id)) : rooms);

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="hierarchy-filters">
      {isAdmin && (
        <select className={sel} value={v.franchise_id} data-testid="hf-franchise"
          onChange={(e) => onChange({ ...EMPTY_HIER, franchise_id: e.target.value })}>
          <option value="">Todas las franquicias</option>
          {franchises.map((f) => <option key={f.franchise_id || f.id} value={f.franchise_id || f.id}>{f.name}</option>)}
        </select>
      )}
      <select className={sel} value={v.institution_id} data-testid="hf-institution"
        onChange={(e) => set({ institution_id: e.target.value, school_id: "", classroom_id: "" })}>
        <option value="">Todas las instituciones</option>
        {insts.map((i) => <option key={i.id} value={i.id}>{i.name}</option>)}
      </select>
      <select className={sel} value={v.school_id} data-testid="hf-school"
        onChange={(e) => set({ school_id: e.target.value, classroom_id: "" })}>
        <option value="">Todos los colegios</option>
        {schoolsF.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <select className={sel} value={v.classroom_id} data-testid="hf-classroom"
        onChange={(e) => set({ classroom_id: e.target.value })}>
        <option value="">Todos los salones</option>
        {roomsF.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      {hierActive(v) && (
        <button type="button" onClick={() => onChange(EMPTY_HIER)} className="text-xs font-bold text-[#A43790] inline-flex items-center gap-1" data-testid="hf-clear">
          <X size={12} /> Limpiar
        </button>
      )}
    </div>
  );
}
